;(function () {
  'use strict'

  angular
    .module('contrast.donut')
    .factory('csDonutRenderService', [
      '$timeout',
      'd3',
      'CS_DONUT_CONSTANTS',
      'COMMON_DELIMITERS',
      csDonutRenderService
    ])

  function csDonutRenderService(
    $timeout,
    d3,
    CS_DONUT_CONSTANTS,
    COMMON_DELIMITERS
  ) {
    var half = 2

    return {
      render: render
    }

    function render(config, selectors, compileFn) {
      var i = 0
      var svg
      var g

      if (angular.isDefined(selectors)) {
        svg = selectors.svg
        g = selectors.g
      } else {
        svg = d3.select(config.chartElement).append('svg')
        g = svg.append('g')
        selectors = {
          svg: svg,
          g: g
        }
      }

      svg
        .attr('width', config.size)
        .attr('height', config.size)
        .style({ width: config.size + 'px' })

      g.attr(
        'transform',
        'translate(' + config.size / half + ',' + config.size / half + ')'
      )

      _renderOuterArc(g, config.size, selectors)

      for (; i < config.data.length; i++) {
        _renderDataArcs(
          selectors,
          config.data[i],
          config.size,
          i,
          compileFn,
          config.onItemClick
        )
      }

      return selectors
    }

    function _renderOuterArc(g, size, selectors) {
      var outerArc = d3.svg
        .arc()
        .innerRadius(size / half - 1)
        .outerRadius(size / half)
        .startAngle(0)
      var outerRing

      if (angular.isDefined(selectors.outerRing)) {
        outerRing = selectors.outerRing
      } else {
        outerRing = g.append('path')
        selectors.outerRing = outerRing
      }

      outerRing
        .datum({ endAngle: 2 * Math.PI })
        .attr('class', CS_DONUT_CONSTANTS.OUTER_RING)
        .attr('d', outerArc)
    }

    function _renderDataArcs(
      selectors,
      dataConfig,
      size,
      index,
      compileFn,
      onItemClick
    ) {
      var arcs = _getArcs(dataConfig)

      var maxWidth
      if (dataConfig.maxWidth) {
        maxWidth = d3.max(arcs, dataConfig.maxWidth)
      } else {
        maxWidth = d3.max(arcs, dataConfig.width)
      }

      var radiusSize = size / half
      var indexOffset = size * (index / 9) + maxWidth

      var getInnerRadius = function (d, i) {
        var width = dataConfig.width(d, i)
        var selectedWidth
        var difference
        if (d.data.selectedValue > 0) {
          selectedWidth = dataConfig.selectedWidth(d, i)
          difference = selectedWidth - width
          width = width + difference * d.data.selectedValue
        }
        var maxWidthOffset = (maxWidth - width) / 2
        return radiusSize - indexOffset - width - maxWidthOffset
      }
      var getOuterRadius = function (d, i) {
        var width = dataConfig.width(d, i)
        var selectedWidth
        var difference
        if (d.data.selectedValue > 0) {
          selectedWidth = dataConfig.selectedWidth(d, i)
          difference = selectedWidth - width
          width = width + difference * d.data.selectedValue
        }
        var maxWidthOffset = (maxWidth - width) / 2
        return radiusSize - indexOffset - maxWidthOffset
      }
      var getArcStrokeWidth = function (d) {
        if (dataConfig.valueAccessor(d) === 0) {
          return 0
        }
        return (1 - d.data.selectedValue) * 1
      }

      var arc = d3.svg
        .arc()
        .innerRadius(getInnerRadius)
        .outerRadius(getOuterRadius)
        .padAngle(function (d, i) {
          var innerRadius = getInnerRadius(d, i)
          var strokeWidth = getArcStrokeWidth(d)
          return Math.atan(strokeWidth / innerRadius)
        })

      var groupName =
        CS_DONUT_CONSTANTS.GROUP + COMMON_DELIMITERS.UNDERSCORE + index
      var donutGroup

      if (angular.isDefined(selectors[groupName])) {
        donutGroup = selectors[groupName].donutGroup
      } else {
        donutGroup = selectors.g.append('g').attr('class', groupName)
        selectors[groupName] = {
          donutGroup: donutGroup
        }
      }

      var donutGroupData = donutGroup
        .selectAll(COMMON_DELIMITERS.DOT + CS_DONUT_CONSTANTS.ARC)
        .data(arcs, dataConfig.idAccessor)

      donutGroupData.exit().remove()

      var paths = donutGroupData
        .enter()
        .append('g')
        .attr('class', CS_DONUT_CONSTANTS.ARC)
        .append('path')
        .each(function (d) {
          this._currentArc = d
          this._currentStrokeWidth = d
        })

      if (angular.isFunction(onItemClick)) {
        paths.on('click', function (d) {
          d3.event.stopPropagation()
          onItemClick(d.data)
        })
      }

      donutGroupData
        .select('path')
        .attr('class', dataConfig.classAccessor)
        .attr('fill', dataConfig.colorAccessor)
        .transition()
        .attrTween('stroke-width', _strokeWidthTween(getArcStrokeWidth))
        .attrTween('d', _arcTween(arc))

      if (angular.isDefined(dataConfig.tooltipTemplate)) {
        paths
          .attr(
            'cs-donut-tooltip',
            angular.isDefined(dataConfig.hasTooltip)
              ? dataConfig.hasTooltip
              : true
          )
          .attr('template', dataConfig.tooltipTemplate)
          .attr('data', function (d, i) {
            return 'config[' + index + '].data[' + i + ']'
          })
          .attr('display-class', function (d, i) {
            return (
              CS_DONUT_CONSTANTS.TOOLTIP_CLASS +
              COMMON_DELIMITERS.UNDERSCORE +
              i
            )
          })
          .attr('cs-donut-tooltip-data-index', index)
          .attr('cs-donut-tooltip-index', function (d, i) {
            return i
          })
          .on('mouseover', function (d, i) {
            var pathEl = this
            $timeout(function () {
              var tooltipEl = angular
                .element('body')
                .find(
                  COMMON_DELIMITERS.DOT +
                    CS_DONUT_CONSTANTS.TOOLTIP_CLASS +
                    COMMON_DELIMITERS.UNDERSCORE +
                    i
                )

              tooltipEl.css(
                'transform',
                _calculateTooltipPosition(
                  selectors.svg[0][0].getBoundingClientRect(),
                  pathEl.getBoundingClientRect(),
                  arc.centroid(d)
                )
              )
              tooltipEl.removeClass(
                CS_DONUT_CONSTANTS.TOOLTIP_CLASS +
                  COMMON_DELIMITERS.UNDERSCORE +
                  i
              )
            })
          })
          .each(function () {
            compileFn(angular.element(this))
          })
      }
    }

    function _getArcs(dataConfig) {
      _.each(dataConfig.data, function (item) {
        item.selectedValue = item.selected ? 1 : 0
      })

      var pie = d3.layout
        .pie()
        .value(dataConfig.valueAccessor)
        .sort(dataConfig.sort)
        .startAngle(-Math.PI)
        .endAngle(Math.PI)

      return pie(dataConfig.data)
    }

    function _calculateTooltipPosition(svg, pathEl, centroid) {
      var desiredPosition = {
        x: svg.left + svg.width / half + centroid[0],
        y: svg.top + svg.height / half + centroid[1]
      }
      var currentPosition = {
        x: pathEl.left + (pathEl.right - pathEl.left) / 2,
        y: pathEl.top
      }

      var translatedX = Math.round(desiredPosition.x - currentPosition.x)
      var translatedY = Math.round(desiredPosition.y - currentPosition.y)

      return 'translate(' + translatedX + 'px, ' + translatedY + 'px)'
    }

    function _arcTween(arc) {
      return function (a) {
        var interpolate = d3.interpolate(this._currentArc, a)
        this._currentArc = interpolate(0)
        return function (t) {
          return arc(interpolate(t))
        }
      }
    }

    function _strokeWidthTween(getArcStrokeWidth) {
      return function (a) {
        var interpolate = d3.interpolate(this._currentStrokeWidth, a)
        this._currentStrokeWidth = interpolate(0)
        return function (t) {
          return getArcStrokeWidth(interpolate(t))
        }
      }
    }
  }
})()
